<template>
  <v-container id="facturacion" tag="section">
    <base-v-component heading="Facturas de los negocios asociados" />
    <base-material-card
      color="indigo"
      icon="mdi-currency-eur"
      inline
      class="px-5 py-3"
    >
      <v-alert class="info">En construcción</v-alert>
    </base-material-card></v-container
  >
</template>


<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {};
</script>

<style>
</style>